import {
  EventMetadata,
  NewDomainEvent,
  TDomainEvent,
} from './types'
import { deviceId, uuidv7 } from '@pogokid/util'

export class DomainEvent {
  constructor(public data: TDomainEvent) {}

  static fromData(
    event: TDomainEvent<string | unknown, string | EventMetadata>
  ): DomainEvent {
    return new DomainEvent({
      ...event,
      payload:
        typeof event.payload === 'string'
          ? JSON.parse(event.payload)
          : event.payload,
      metadata:
        typeof event.metadata === 'string'
          ? JSON.parse(event.metadata)
          : event.metadata,
    })
  }

  static fromNewPayload<T = unknown, M = EventMetadata>(
    event: NewDomainEvent<T, M>
  ): DomainEvent {
    const now = new Date()
    const device = deviceId()

    return new DomainEvent({
      ...event,
      id: uuidv7(),
      device_id: device.id,
      payload:
        typeof event.payload === 'string'
          ? JSON.parse(event.payload)
          : event.payload,
      metadata:
        typeof event.metadata === 'string'
          ? JSON.parse(event.metadata)
          : event.metadata,
      timestamp: now.toISOString(),
      created_at: now.toISOString(),
    })
  }

  get id(): string {
    return this.data.id
  }

  get profile_id(): string {
    return this.data.profile_id
  }

  get user_id(): string | null {
    return this.data.user_id ?? null
  }

  get aggregate_type() {
    return this.data.aggregate_type
  }

  get event_type() {
    return this.data.event_type
  }

  get sequence_number() {
    return this.data.sequence_number
  }

  get payload() {
    return this.data.payload
  }

  get correlation_id(): string | null {
    return this.data.correlation_id ?? null
  }

  setCorrelationId(value: string | null) {
    this.data.correlation_id = value
    return this
  }

  intoSerialised(): TDomainEvent<string, string> {
    return {
      ...this.data,
      payload: JSON.stringify(this.data.payload),
      metadata: JSON.stringify(this.data.metadata),
    }
  }

  intoSerialisedWithoutSequences(): TDomainEvent<
    string,
    string
  > {
    const { sequence_number, device_sequence_number, ...data } =
      this.data
    return {
      ...data,
      payload: JSON.stringify(this.data.payload),
      metadata: JSON.stringify(this.data.metadata),
    }
  }
}
